import _ from 'underscore';
import { FileBase } from './FileBase';
import { ArrayBase } from './ArrayBase';

export class FilePlusArrayBase extends FileBase {
  static arrayField = undefined; // subclasses MUST define this var

  isValid() {
    const arr = this[this.constructor.arrayField];
    return (arr && arr.length > 0) || super.isValid();
  }

  isEqualTo(other) {
    const arr = this[this.constructor.arrayField];
    const otherArr = other[this.constructor.arrayField];

    return (
      this.isValid() &&
      other.isValid() &&
      // both array & file are equal
      ArrayBase.isEqual(arr, otherArr) &&
      super.isEqualTo(other)
    );
  }

  static count(target) {
    let len = 0;
    if (target && target[this.arrayField]) {
      len = ArrayBase.count(target[this.arrayField]);
    }
    if (target && target.uploaded && _.isObject(target.uploaded)) {
      len += 1;
    }
    return len;
  }
}
